module.exports = __webpack_public_path__ + "img/ar.497d51c4.svg";